import { DataGridTypes } from "devextreme-react/cjs/data-grid";
import { csvSaver } from "./csvSaver";
import { exportToPDF } from "./exportToPDF";
import { xlsxSaver } from "./xlsxSaver";
import { DataGridCell } from 'devextreme/common/export/pdf';
import { Workbook } from 'exceljs';
import { PdfOrientation } from "../types";

export function handleExport(title: string, headerTitleForSheet?: string, reportHeaderTagLine?: string, customizeCell?: (({ gridCell, excelCell }: { gridCell?: DataGridCell; excelCell?: any; }) => void), handleNewSheet?: ((workBook: Workbook, headerImageId: number) => Promise<void>), pdfOrientation?: PdfOrientation) {
    return (e: DataGridTypes.ExportingEvent) => {
        switch (e.format) {
            case 'xlsx':
                xlsxSaver(e, title, headerTitleForSheet, reportHeaderTagLine, customizeCell, handleNewSheet);
                break;
            case 'csv':
                csvSaver(e, title);
                break;
            case 'pdf':
                exportToPDF({
                    e, title, headerTitleForSheet, reportHeaderTagLine, pdfOrientation
                });
                break;
            default:
                return;
        }
    };
}
